import { render, staticRenderFns } from "./Agriculture.vue?vue&type=template&id=3b4c5b77"
import script from "./Agriculture.vue?vue&type=script&lang=js"
export * from "./Agriculture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports